import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableDefaultVariants = {
  "size": "md"
}
const tableCompoundVariants = []

const tableSlotNames = [
  [
    "root",
    "table__root"
  ],
  [
    "header",
    "table__header"
  ],
  [
    "headerRow",
    "table__headerRow"
  ],
  [
    "headerCell",
    "table__headerCell"
  ],
  [
    "body",
    "table__body"
  ],
  [
    "row",
    "table__row"
  ],
  [
    "cell",
    "table__cell"
  ],
  [
    "selectionCell",
    "table__selectionCell"
  ],
  [
    "sortIcon",
    "table__sortIcon"
  ],
  [
    "viewIcon",
    "table__viewIcon"
  ],
  [
    "deleteIcon",
    "table__deleteIcon"
  ]
]
const tableSlotFns = /* @__PURE__ */ tableSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableDefaultVariants, getSlotCompoundVariant(tableCompoundVariants, slotName))])

const tableFn = memo((props = {}) => {
  return Object.fromEntries(tableSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...tableDefaultVariants, ...compact(variants) })

export const table = /* @__PURE__ */ Object.assign(tableFn, {
  __recipe__: false,
  __name__: 'table',
  raw: (props) => props,
  variantKeys: tableVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tableVariantKeys)
  },
  getVariantProps
})